<template>
    <div :class="{ 'app-container':true, 'show-menu':menuClass }">
        <perfect-scrollbar ref="scrollbar" @ps-scroll-y="onScroll">
            <!-- 全局悬浮btn -->
            <Transition name="fade">
                <div v-if="show">
                    <div class="btn-container">
                        <div class="btn-item" @click="visible = true"><img :src="Icon1" /><span>申请试用</span></div>
                        <el-tooltip placement="left" effect="light">
                            <template #content><div style="font-size:16px; padding:14px;">0752-2605 509</div></template>
                            <div class="btn-item"><img :src="Icon2" /><span>服务热线</span></div>
                        </el-tooltip> 
                    </div>
                    <div class="btn-container" style="transform:translateY(calc( -50% + 130px ))">
                        <div class="btn-item" style="padding:14px;" @click="handleGo(0)"  ><img :src="Icon3" /></div>
                    </div>
                </div>
            </Transition>
            <!-- 全局表单 -->
            <CustomModal :visible="visible" @onClose="handleClose" />
            <Header />
            <router-view></router-view>
            <Footer @onScroll="value=>handleGo(value)" />
        </perfect-scrollbar>
    </div>
</template>

<script>   
    import { markAction } from '@/api/global.js';
    import CustomModal from '@/components/CustomModal.vue';
    import Icon1 from '@/assets/float-btn-1.png';
    import Icon2 from '@/assets/float-btn-2.png';
    import Icon3 from '@/assets/float-btn-3.png';
    import Header from '@/components/header/index.vue';
    import Footer from '@/components/footer/index.vue';
    export default {
        name:'layout',
        data(){
            return {
                Icon1,
                Icon2,
                Icon3,
                menuClass:false,
                visible:false,
                show:false
            }
        },
        methods:{
            onScroll(event){
                const el = this.$refs.scrollbar.$el;
                if ( !el ) return;
                if ( el.scrollTop > 560 ) {
                    this.menuClass = true;
                } else {
                    this.menuClass = false;
                }
                // 只有首页遵循滚动显示，其他页面默认进入就显示
                if ( this.$route.path && this.$route.path !== '/home' && this.$route.path !== '/' ) {
                    this.show = true;
                    return;
                }
                if ( el.scrollTop > 680 ) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            },
            handleClose(){
                this.visible = false;
            },
            handleGo(value){
                const el = this.$refs.scrollbar.$el;
                if ( !el ) return;
                el.scrollTop = value;
            }
        },
        beforeCreate(){
            console.log('before create...');
            // 判断如果是移动端，则跳转至移动端域名
            function isMobileDevice() {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // 移动设备浏览器的用户代理字符串通常包含以下信息之一
                var isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());

                return isMobile;
            }
            if ( isMobileDevice()) {
                window.location.href = 'http://m.ifmcs.com';
            }
        },
        mounted(){
            markAction({ operationType:'访问网站' });
             // 自适应逻辑
            const baseSize = 14;
            function setRem(){
                const scale = document.documentElement.clientWidth / 1920;
                const result = baseSize * Math.min(scale, 2);
                document.documentElement.style.fontSize = result + 'px';
            
            }
            window.addEventListener('resize', setRem);
            setRem();
        },
        
        watch:{
            '$route.path':{
                immediate:true,
                handler:function(newVal){
                    const scrollbar = this.$refs.scrollbar;
                    const el = scrollbar ? scrollbar.$el : null;
                    if ( el ) {
                        el.scrollTop = 0;
                    }
                    if ( this.$route.path === '/home' || this.$route.path === '/' ) {
                        this.show = false;
                    } else {
                        this.show = true;
                    }
                    
                }
            }      
        },
        components:{
            Header,
            Footer,
            CustomModal
        }
    }
</script>

<style>
.ps {
  height:100%;
}
.btn-container {
    position:fixed;
    right:0;
    top:50%;
    transform:translateY(-50%);
    z-index:10;
}
.btn-container .btn-item {
    padding:10px;
    background:#335cff;
    color:#fff;
    font-size:12px;
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content: center;
    position:relative;
    cursor: pointer;
}
.btn-container .btn-item:hover {
    background:#4569f8;
}
.btn-container .btn-item::after {
    content:'';
    position:absolute;
    bottom:0;
    width:40px;
    height:1px;
    background:rgba(255, 255, 255, 0.25);
}
.btn-container .btn-item:last-child::after {
    content:'';
    display:none;
}
.btn-container .btn-item .el-icon {
    margin-bottom:6px;
}
.btn-container .btn-item:first-child {
    border-top-left-radius: 4px;
}
.btn-container .btn-item:last-child {
    border-bottom-left-radius: 4px;
}
.fade-enter-active, .fade-leave-active {
    transition:opacity 1s ease-out;
}
.fade-enter-from, .fade-leave-to {
    opacity:0;
}
</style>

